(() => {
  if (customElements.get('mobile-reels')) return;

  class MobileReels extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.feed = this.querySelector('[data-reels-feed]');
      this.closeBtns = this.querySelectorAll('[data-reels-close]');
      this.cartBtns = this.querySelectorAll('[data-reels-cart]');
      this.muted = true;
      this.activeIndex = 0;
      this.observer = null;
      this.refreshSlides();

      this.onOpenClick = (e) => {
        const btn = e.target.closest('[data-reels-open]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        this.open({ trigger: btn });
      };
      document.addEventListener('click', this.onOpenClick);

      this.closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.close());
      });

      this.cartBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openCart();
        });
      });

      this.querySelectorAll('[data-reels-mute]').forEach((btn) => {
        btn.addEventListener('click', () => this.toggleMute());
      });

      this.querySelectorAll('[data-reels-share]').forEach((btn) => {
        btn.addEventListener('click', (e) => this.share(e.currentTarget));
      });

      this.querySelectorAll('[data-reels-atc]').forEach((btn) => {
        btn.addEventListener('click', (e) => this.addToCart(e.currentTarget));
      });

      this.querySelectorAll('.mobile-reels__product').forEach((card) => this.bindProductCard(card));
      this.hideWhatsappPrices();

      this.bindSlideVideos(this);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });

      this.onViewportChange = () => this.syncViewport();
      this.syncViewport();
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.onViewportChange);
        window.visualViewport.addEventListener('scroll', this.onViewportChange);
      } else {
        window.addEventListener('resize', this.onViewportChange);
      }
      window.addEventListener('load', this.onViewportChange);

      this.openFromQuery();
    }

    refreshSlides() {
      this.slides = Array.from(this.querySelectorAll('[data-reels-slide]:not([data-reels-empty])'));
    }

    bindSlideVideos(root) {
      const slides = root.matches && root.matches('[data-reels-slide]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-reels-slide]'));

      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video || video.dataset.reelsBound) return;
        video.dataset.reelsBound = 'true';
        video.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    bindSlideActions(slide) {
      const shareBtn = slide.querySelector('[data-reels-share]');
      const muteBtn = slide.querySelector('[data-reels-mute]');
      const atcBtn = slide.querySelector('[data-reels-atc]');
      const productCard = slide.querySelector('.mobile-reels__product');

      if (shareBtn && !shareBtn.dataset.reelsBound) {
        shareBtn.dataset.reelsBound = 'true';
        shareBtn.addEventListener('click', (e) => this.share(e.currentTarget));
      }
      if (muteBtn && !muteBtn.dataset.reelsBound) {
        muteBtn.dataset.reelsBound = 'true';
        muteBtn.addEventListener('click', () => this.toggleMute());
      }
      if (atcBtn && !atcBtn.dataset.reelsBound) {
        atcBtn.dataset.reelsBound = 'true';
        atcBtn.addEventListener('click', (e) => this.addToCart(e.currentTarget));
      }
      this.bindProductCard(productCard);
      this.bindSlideVideos(slide);
    }

    bindProductCard(card) {
      if (!card || card.dataset.reelsBound) return;
      card.dataset.reelsBound = 'true';

      const collapseBtn = card.querySelector('[data-reels-collapse]');
      if (collapseBtn && !collapseBtn.dataset.reelsBound) {
        collapseBtn.dataset.reelsBound = 'true';
        collapseBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleProductCard(card);
        });
      }

      card.addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target.closest('.mobile-reels__product-actions')) return;
        if (e.target.closest('[data-reels-product-view]')) return;
        this.toggleProductCard(card);
      });
    }

    toggleProductCard(target) {
      const card = target.classList && target.classList.contains('mobile-reels__product')
        ? target
        : target.closest('.mobile-reels__product');
      if (!card) return;

      const collapsed = card.classList.toggle('is-collapsed');
      const btn = card.querySelector('[data-reels-collapse]');
      const actions = card.querySelector('.mobile-reels__product-actions');

      if (btn) {
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        btn.setAttribute(
          'aria-label',
          collapsed ? (this.dataset.expandLabel || '') : (this.dataset.collapseLabel || '')
        );
      }

      if (actions) {
        actions.setAttribute('aria-hidden', collapsed ? 'true' : 'false');
        if (collapsed) {
          actions.setAttribute('inert', '');
        } else {
          actions.removeAttribute('inert');
        }
      }
    }

    ensureSlideFromTrigger(trigger) {
      if (!trigger || !this.feed) return -1;
      const productId = trigger.dataset.reelsProductId;
      if (!productId) return -1;

      this.refreshSlides();
      const existing = this.slides.findIndex((slide) => slide.dataset.productId === String(productId));
      if (existing >= 0) return existing;

      const videoSrc = trigger.dataset.reelsVideoSrc;
      if (!videoSrc) return -1;

      const emptySlide = this.feed.querySelector('[data-reels-empty]');
      if (emptySlide) emptySlide.remove();

      const slide = this.buildSlide({
        productId,
        videoSrc,
        title: trigger.dataset.reelsTitle || '',
        price: trigger.dataset.reelsPrice || '',
        image: trigger.dataset.reelsImage || '',
        url: this.reelShareUrl(trigger.dataset.reelsUrl, trigger.dataset.reelsProductHandle),
        handle: trigger.dataset.reelsProductHandle || '',
        variantId: trigger.dataset.reelsVariantId || '',
        available: trigger.dataset.reelsAvailable !== 'false',
        whatsapp: this.usesWhatsapp(trigger.dataset.reelsCollections)
      });

      this.feed.prepend(slide);
      this.bindSlideActions(slide);
      this.refreshSlides();
      return 0;
    }

    buildSlide(data) {
      const slide = document.createElement('article');
      slide.className = 'mobile-reels__slide';
      slide.setAttribute('data-reels-slide', '');
      slide.dataset.productId = data.productId;
      if (data.handle) slide.dataset.productHandle = data.handle;
      slide.dataset.shareUrl = this.reelShareUrl(data.url, data.handle);
      slide.dataset.shareTitle = data.title;

      const video = document.createElement('video');
      video.className = 'mobile-reels__video';
      video.src = data.videoSrc;
      video.setAttribute('playsinline', '');
      video.loop = true;
      video.muted = true;
      video.preload = 'metadata';
      slide.appendChild(video);

      const side = document.createElement('div');
      side.className = 'mobile-reels__side';

      const shareBtn = document.createElement('button');
      shareBtn.type = 'button';
      shareBtn.className = 'mobile-reels__side-btn';
      shareBtn.setAttribute('data-reels-share', '');
      shareBtn.innerHTML = '<svg class="mobile-reels__share-icon" viewBox="0 0 512 512" aria-hidden="true" focusable="false"><path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"/></svg>';
      side.appendChild(shareBtn);

      const muteBtn = document.createElement('button');
      muteBtn.type = 'button';
      muteBtn.className = 'mobile-reels__side-btn';
      muteBtn.setAttribute('data-reels-mute', '');
      muteBtn.setAttribute('aria-pressed', 'true');
      const existingMute = this.querySelector('[data-icon-mute]');
      const existingUnmute = this.querySelector('[data-icon-unmute]');
      const muteSpan = document.createElement('span');
      muteSpan.setAttribute('data-icon-mute', '');
      if (existingMute) muteSpan.appendChild(existingMute.cloneNode(true));
      const unmuteSpan = document.createElement('span');
      unmuteSpan.setAttribute('data-icon-unmute', '');
      unmuteSpan.hidden = true;
      if (existingUnmute) unmuteSpan.appendChild(existingUnmute.cloneNode(true));
      muteBtn.appendChild(muteSpan);
      muteBtn.appendChild(unmuteSpan);
      side.appendChild(muteBtn);
      slide.appendChild(side);

      const product = document.createElement('div');
      product.className = 'mobile-reels__product is-collapsed';
      if (data.whatsapp) product.classList.add('is-whatsapp');
      product.dir = document.documentElement.lang === 'ar' ? 'rtl' : 'ltr';

      const info = document.createElement('div');
      info.className = 'mobile-reels__product-info';

      const thumb = document.createElement('div');
      thumb.className = 'mobile-reels__product-thumb';
      if (data.image) {
        const img = document.createElement('img');
        img.src = data.image;
        img.alt = data.title;
        thumb.appendChild(img);
      }
      if (data.url) {
        const viewLink = document.createElement('a');
        viewLink.href = this.productViewUrl(data.url);
        viewLink.className = 'mobile-reels__product-view';
        viewLink.setAttribute('data-reels-product-view', '');
        viewLink.setAttribute('aria-label', this.dataset.viewLabel || '');
        viewLink.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>';
        thumb.appendChild(viewLink);
      }

      const meta = document.createElement('div');
      meta.className = 'mobile-reels__product-meta';
      const titleEl = document.createElement('p');
      titleEl.className = 'mobile-reels__product-title';
      titleEl.textContent = data.title;
      meta.appendChild(titleEl);
      if (!data.whatsapp) {
        const priceEl = document.createElement('p');
        priceEl.className = 'mobile-reels__product-price';
        priceEl.textContent = data.price;
        meta.appendChild(priceEl);
      }
      info.appendChild(thumb);
      info.appendChild(meta);

      const collapseBtn = document.createElement('button');
      collapseBtn.type = 'button';
      collapseBtn.className = 'mobile-reels__collapse';
      collapseBtn.setAttribute('data-reels-collapse', '');
      collapseBtn.setAttribute('aria-expanded', 'false');
      collapseBtn.setAttribute('aria-label', this.dataset.expandLabel || '');
      collapseBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      info.appendChild(collapseBtn);

      const actions = document.createElement('div');
      actions.className = 'mobile-reels__product-actions';
      actions.setAttribute('aria-hidden', 'true');
      actions.setAttribute('inert', '');

      const actionsInner = document.createElement('div');
      actionsInner.className = 'mobile-reels__product-actions-inner';

      product.appendChild(info);

      if (data.whatsapp) {
        const phone = this.dataset.whatsappPhone || '966500369544';
        const productUrl = this.whatsappProductUrl(data.url);
        const message = `مرحباً، أود الاستفسار/الطلب بخصوص هذا المنتج:\n\n🛒 اسم المنتج: ${data.title || ''}\n🔗 رابط المنتج: ${productUrl}`;
        const whatsappLink = document.createElement('a');
        whatsappLink.className = 'mobile-reels__whatsapp';
        whatsappLink.setAttribute('data-reels-whatsapp', '');
        whatsappLink.target = '_blank';
        whatsappLink.rel = 'noopener noreferrer';
        whatsappLink.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        whatsappLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>';
        const whatsappLabel = document.createElement('span');
        whatsappLabel.textContent = this.dataset.whatsappLabel || 'Order via WhatsApp';
        whatsappLink.appendChild(whatsappLabel);
        actionsInner.appendChild(whatsappLink);
      } else {
      const atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'mobile-reels__atc';
      atcBtn.setAttribute('data-reels-atc', '');
      atcBtn.dataset.variantId = data.variantId;
      atcBtn.dataset.successLabel = this.dataset.atcSuccess || '';
      if (data.available) {
        atcBtn.textContent = this.dataset.atcLabel || '';
      } else {
        atcBtn.textContent = this.dataset.soldOut || '';
        atcBtn.disabled = true;
      }

      actionsInner.appendChild(atcBtn);

      if (data.available) {
        const buyForm = document.createElement('form');
        buyForm.method = 'post';
        buyForm.action = this.dataset.cartAddUrl || '/cart/add';
        buyForm.className = 'mobile-reels__buy-form';
        buyForm.setAttribute('accept-charset', 'UTF-8');

        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = data.variantId;

        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';

        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = this.dataset.checkoutUrl || '/checkout';

        const buyBtn = document.createElement('button');
        buyBtn.type = 'submit';
        buyBtn.className = 'mobile-reels__buy';
        buyBtn.setAttribute('data-reels-buy', '');
        buyBtn.textContent = this.dataset.buyNowLabel || '';

        buyForm.appendChild(idInput);
        buyForm.appendChild(qtyInput);
        buyForm.appendChild(returnInput);
        buyForm.appendChild(buyBtn);
        actionsInner.appendChild(buyForm);
      }
      }

      actions.appendChild(actionsInner);
      product.appendChild(actions);
      slide.appendChild(product);
      return slide;
    }

    syncViewport() {
      const vv = window.visualViewport;
      if (!vv) return;
      this.style.setProperty('--reels-vv-top', `${Math.round(vv.offsetTop)}px`);
      this.style.setProperty('--reels-vv-left', `${Math.round(vv.offsetLeft)}px`);
      this.style.setProperty('--reels-vv-width', `${Math.round(vv.width)}px`);
      this.style.setProperty('--reels-vv-height', `${Math.round(vv.height)}px`);
    }

    open(options = {}) {
      let startIndex = 0;
      if (options.trigger && options.trigger.dataset.reelsProductId) {
        const index = this.ensureSlideFromTrigger(options.trigger);
        startIndex = index >= 0 ? index : 0;
      } else if (typeof options.startIndex === 'number' && options.startIndex >= 0) {
        startIndex = options.startIndex;
      }

      this.hideWhatsappPrices();
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-reels-open');
      this.syncViewport();
      this.refreshSlides();
      this.activeIndex = this.slides[startIndex] ? startIndex : 0;
      this.setupObserver();

      requestAnimationFrame(() => {
        this.syncViewport();
        const slide = this.slides[this.activeIndex];
        if (slide) slide.scrollIntoView({ block: 'start' });
        this.playActive();
      });
      window.setTimeout(() => this.syncViewport(), 300);
      this.updateCartCounts();
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-reels-open');
      this.pauseAll();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    openCart() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }

      const originalTrigger = document.querySelector(
        'header .js-open-cart-drawer, .header__icon--cart, #cart-icon-bubble'
      );
      if (originalTrigger) {
        originalTrigger.click();
        return;
      }

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
    }

    setupObserver() {
      if (!this.feed) return;
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.65) return;
            const index = this.slides.indexOf(entry.target);
            if (index < 0) return;
            this.activeIndex = index;
            this.playActive();
          });
        },
        { root: this.feed, threshold: 0.65 }
      );

      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    playActive() {
      this.slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.muted = this.muted;
        if (index === this.activeIndex) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (err) {
            // ignore seek errors on unloaded media
          }
        }
      });
      this.syncMuteUI();
    }

    pauseAll() {
      this.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    }

    toggleMute() {
      this.muted = !this.muted;
      this.querySelectorAll('video').forEach((video) => {
        video.muted = this.muted;
      });
      this.syncMuteUI();
    }

    syncMuteUI() {
      this.querySelectorAll('[data-reels-mute]').forEach((btn) => {
        const muteIcon = btn.querySelector('[data-icon-mute]');
        const unmuteIcon = btn.querySelector('[data-icon-unmute]');
        if (muteIcon) muteIcon.hidden = !this.muted;
        if (unmuteIcon) unmuteIcon.hidden = this.muted;
        btn.setAttribute('aria-pressed', this.muted ? 'true' : 'false');
      });
    }

    whatsappProductUrl(url) {
      try {
        const viewUrl = new URL(url || '', window.location.origin);
        viewUrl.searchParams.delete('reel');
        return viewUrl.href;
      } catch (err) {
        return url || window.location.href;
      }
    }

    productViewUrl(url) {
      try {
        const viewUrl = new URL(url || '', window.location.origin);
        viewUrl.searchParams.delete('reel');
        return `${viewUrl.pathname}${viewUrl.search}${viewUrl.hash}` || url || '';
      } catch (err) {
        return url || '';
      }
    }

    reelShareUrl(url, handle) {
      const fallback = window.location.href;
      try {
        const shareUrl = new URL(url || fallback, window.location.origin);
        if (handle) {
          shareUrl.searchParams.set('reel', handle);
        } else if (!shareUrl.searchParams.get('reel')) {
          shareUrl.searchParams.set('reel', '1');
        }
        return shareUrl.toString();
      } catch (err) {
        return url || fallback;
      }
    }

    openFromQuery() {
      const params = new URLSearchParams(window.location.search);
      const reel = params.get('reel');
      if (!reel) return;
      if (!window.matchMedia('(max-width: 767px)').matches) return;

      this.refreshSlides();
      let index = -1;
      if (reel !== '1') {
        index = this.slides.findIndex((slide) => slide.dataset.productHandle === reel);
      }
      if (index < 0) {
        const path = window.location.pathname.replace(/\/$/, '');
        index = this.slides.findIndex((slide) => {
          try {
            const sharePath = new URL(slide.dataset.shareUrl, window.location.origin).pathname.replace(/\/$/, '');
            return sharePath === path;
          } catch (err) {
            return false;
          }
        });
      }
      if (index < 0) index = 0;

      requestAnimationFrame(() => {
        this.open({ startIndex: index });
      });
    }

    async share(btn) {
      const slide = btn.closest('[data-reels-slide]');
      const title = (slide && slide.dataset.shareTitle) || document.title;
      const url = this.reelShareUrl(
        (slide && slide.dataset.shareUrl) || window.location.href,
        slide && slide.dataset.productHandle
      );
      const text = [this.dataset.shareText || '', title].filter(Boolean).join(' — ');

      try {
        if (navigator.share) {
          await navigator.share({ title, text, url });
          return;
        }
      } catch (err) {
        if (err && err.name === 'AbortError') return;
      }

      try {
        await navigator.clipboard.writeText(url);
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 1200);
      } catch (err) {
        // ignore clipboard failures
      }
    }

    hideWhatsappPrices() {
      this.querySelectorAll('.mobile-reels__product.is-whatsapp, .mobile-reels__product:has(.mobile-reels__whatsapp)').forEach((card) => {
        card.classList.add('is-whatsapp');
        card.querySelectorAll('.mobile-reels__product-price').forEach((price) => price.remove());
      });
    }

    usesWhatsapp(collectionHandles) {
      const allowed = this.dataset.whatsappCollections || '';
      if (!allowed || allowed === '|' || !collectionHandles) return false;

      return collectionHandles.split(',').some((handle) => {
        const token = `|${handle.trim()}|`;
        return handle.trim() && allowed.includes(token);
      });
    }

    async addToCart(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalLabel = btn.textContent;
      const successLabel = btn.dataset.successLabel || originalLabel;
      const cartAdd = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add';

      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      btn.classList.add('is-loading');

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer
          ? `${cartDrawer.dataset.section},cart-icon-bubble`
          : 'cart-icon-bubble';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(
            (typeof data.description === 'string' && data.description) ||
              data.message ||
              'Add to cart failed'
          );
        }

        if (window.customElements && customElements.get('product-form') && data.sections) {
          try {
            const ProductFormCtor = customElements.get('product-form');
            if (ProductFormCtor && typeof ProductFormCtor.updateCartIcon === 'function') {
              ProductFormCtor.updateCartIcon(data);
            }
          } catch (err) {
            // ignore icon update errors
          }
        }

        if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
          try {
            await cartDrawer.renderContents(data, false, btn);
          } catch (err) {
            if (typeof cartDrawer.refresh === 'function') {
              await cartDrawer.refresh(true);
            }
          }
        } else if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          await cartDrawer.refresh(true);
        }

        await this.updateCartCounts();

        document.dispatchEvent(
          new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: { cart: data, variantId: data.variant_id }
          })
        );

        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.textContent = successLabel;

        setTimeout(() => {
          btn.classList.remove('is-success');
          btn.textContent = originalLabel;
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        }, 1600);
      } catch (err) {
        console.error(err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.textContent = originalLabel;
      }
    }

    async updateCartCounts() {
      const cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart';

      try {
        const cartRes = await fetch(`${cartUrl}.js`);
        if (!cartRes.ok) return;
        const cart = await cartRes.json();
        const count = cart.item_count || 0;

        const mobileBadge = document.getElementById('mobile-cart-badge');
        if (mobileBadge) mobileBadge.innerText = count;

        this.querySelectorAll('[data-reels-cart-badge]').forEach((badge) => {
          badge.textContent = count;
          if (count > 0) {
            badge.removeAttribute('hidden');
          } else {
            badge.setAttribute('hidden', '');
          }
        });
      } catch (err) {
        // ignore badge refresh errors
      }
    }
  }

  customElements.define('mobile-reels', MobileReels);
})();
